export const text = {
  login: "Login",
  welcome: "Welcome",
  welcomedescription: "Enter Your Email ID to continue",
  email: "Email",
  getotp: "Get OTP",
  processing: "Processing",
  Pleaseenteravalidemailaddress: "Please enter a valid email address",
  Enteryouremailaddress: "Enter your email address",
};
